import Spinner from './Spinner';

interface Props {
  label?: string;
  fullscreen?: boolean;
}

export default function LoadingScreen({ label, fullscreen = false }: Props) {
  const container = fullscreen
    ? 'min-h-screen flex flex-col items-center justify-center gap-3'
    : 'h-full w-full flex flex-col items-center justify-center gap-3';

  return (
    <div className={container}>
      <Spinner size="lg" />
      {label && (
        <p className="font-mono text-[11px] tracking-wide uppercase text-slate-400 dark:text-slate-500">
          {label}
        </p>
      )}
    </div>
  );
}
